import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.services'

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['../promotion.component.css'],
})
export class FooterComponent implements OnInit {

    en = {}
    showEN = true

    constructor(private auth: AuthService) {
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

}



// WEBPACK FOOTER //
// ./src/app/promotion/layout-promotion/footer.component.ts